import { DragEvent, useCallback } from "react";

const onDragStart = (event: DragEvent, nodeType: string) => {
    event.dataTransfer.setData("application/reactflow", nodeType);
    event.dataTransfer.effectAllowed = "move";
};

export function DragabbleNode({
    type,
    children,
    isDisabled,
    visible = true,
}: {
    isDisabled?: boolean;
    type: string;
    visible?: boolean;
    children: JSX.Element;
}): JSX.Element {
    const handleDragStart = useCallback(
        (event: DragEvent) => {
            if (isDisabled) {
                return;
            }
            onDragStart(event, type);
        },
        [isDisabled, type]
    );
    // this is a very dumb way to do this.
    // but i am just cleaning up the logic to make it more readable
    if (!visible) {
        return <></>;
    }

    return (
        <div onDragStart={handleDragStart} draggable={!isDisabled}>
            {children}
        </div>
    );
}
